import React, { useState, useEffect } from 'react';
import './StoreList.scss';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { NavBarNames } from '../../../config/NavBarNameList';
import { createAction } from '../../../utils';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import BaseListContainer from '../../base/BaseListContainer';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';
import { ActionsDropdownForItem } from '../../../components/base/ActionsDropdown';
import { downloadZipFiles } from './QRCodeDownloadUtil';
import './StoreCodeList.scss';
import BasePrompt from '../../../components/base/prompt/BasePrompt';
import { ImportResource } from '../../../models/DownloadImportModel';
import CustomSwitchButton from '../../../components/base/CustomSwitchButton';
import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';

const ExportStoreCodePop = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const [exportSeparate, setExportSeparate] = useState(false);
  const brandList = useSelector((state) => state.brand.brandList);
  const [selectedBrand, setSelectedBrand] = useState([]);

  const formPart = (
    <div className="performance-report-prompt-other-body">
      <div className="other-body-multi-selector">
        <BaseMultipleSelectorV2
          title={'Select Brand(s)'}
          size={['shorter']}
          namespace="brand"
          searchPlaceholder="Search by brand name"
          data={{
            sourceData: brandList,
            targetData: selectedBrand,
            targetChange: setSelectedBrand,
          }}
        />
      </div>
      <div className="other-body-title">
        Export in separate files by brand(s)
      </div>
      <div className="other-body-discription">
        If On, multiple files will be downloaded based on different brands. If
        off, all the data merge into one file.
      </div>
      <CustomSwitchButton
        defaultChecked={exportSeparate}
        onChange={(isChecked) => {
          setExportSeparate(isChecked);
        }}
      />
    </div>
  );

  return (
    <BasePrompt
      show={show}
      closeAction={() => {
        onClose();
      }}
      rightButton={{
        text: 'Export',
        action: () => {
          const exportData = {
            brands: selectedBrand.map((item)=> item.pk),
            separate_files: exportSeparate,
          };
          dispatch(
            createAction('downloadAndImport/createDownloadTask')({
              from: ImportResource.storeQRCodeExport,
              related: {
                filterConditions: JSON.stringify(exportData),
              },
            }),
          );
          onClose();
        },
      }}
      title={'Export Cover Photo'}
      otherBody={() => formPart}
    />
  );
};

export default function StoreCodeList() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [showExportPrompt, setShowExportPrompt] = useState(false);

  const buttons = [
    <AuthButton
      title="Export Cover Photo"
      action={() => {
        setShowExportPrompt(true);
      }}
      requires={PermissionCodes.addExportjob}
    />,
  ];

  const { listFields, dataList, pageInfo, totalPage, totalCount, checkedList } =
    useSelector((state) => ({
      listFields: state.storeModel.codeListDisplayFields,
      dataList: state.storeModel.pagedStoreList,
      pageInfo: state.storeModel.pageInfo,
      totalPage: state.storeModel.totalPage,
      totalCount: state.storeModel.totalCount,
      checkedList: state.storeModel.checkedList,
    }));

  const groupActions = [
    {
      name: 'Download',
      action: () => {
        if(checkedList.length === 0){
          return;
        }
        dispatch({ type: 'storeModel/downloadStoreCodes' });
      },
    },
  ];

  const tabs = [
    {
      name: '',
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          listContent={
            <BaseListContainer
              customClassName={'store-code-list-table'}
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'storeModel'}
              permissionGroup={PermissionCodes.store}
              deleteInfo={{
                data: [],
                title: 'store',
                relatedName: '',
                onComfirm: {},
                relatedSections: DELETE_RELATED_SECTIONS.STORE,
              }}
              sortable={false}
              rankDisabled
              useCustomCommonActions
              customCommonActions={(item) => {
                const actions = [
                  {
                    name: 'Download',
                    action: () => {
                      downloadZipFiles(item.codeDownloadImage, item?.storeName);
                      dispatch({
                        type: 'admin/createAuditLog',
                        payload: {
                          data: {
                            dataType: 'store',
                            id: item.pk,
                          }
                        },
                      });
                    },
                  },
                ];
                return (
                  <ActionsDropdownForItem object={item} actions={actions} />
                );
              }}
            />
          }
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch({ type: 'storeModel/clearData' });
    dispatch(createAction('brand/getCurrentPageBrands')({isAll: true}));
    const queryString = require('query-string');
    if (queryString) {
      const querySearch = queryString.parse(location.search);
      const stringPage = querySearch['page'] || 1;
      const searchKey = querySearch['search'] || '';
      const page = parseInt(stringPage);
      const queryData = {
        page,
        search: searchKey,
        reverse: true,
      };
      dispatch(createAction('storeModel/getPagedStoreList')(queryData));
    }
  }, [dispatch, location]);

  return (
    <div className="store-code-list-container">
      <CustomListComponent
        caution={{
          detail: ' ',
          title: NavBarNames.storeCodes,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={false}
      />
      <ExportStoreCodePop
        show={showExportPrompt}
        onClose={() => setShowExportPrompt(false)}
      />
    </div>
  );
}
